import React from 'react';
import isEmpty from 'lodash/isEmpty';
import s from './SmallTextLayout.scss';
const SmallTextLayout = ({ headerImage, backgroundColor, children })=>{
    const customBg = !isEmpty(backgroundColor) ? backgroundColor : undefined;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            backgroundColor: customBg
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['header'],
        style: {
            backgroundImage: headerImage ? `url(${headerImage})` : undefined
        }
    }), children);
};
SmallTextLayout.displayName = 'SmallTextLayout';
export default SmallTextLayout;

//# sourceMappingURL=SmallTextLayout.js.map